import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Modal,
  TextareaAutosize,
  Stack,
  Paper,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Grid,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

const API_URL = process.env.REACT_APP_NEWS_API_URL;

const DashboardNews = ({ topbarHeight = 64 }) => {
  const [open, setOpen] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
  title: "",
  description: "",
  start_date: "",
  end_date: "",
});


  // ================= FETCH ALL NEWS =================
  const fetchNews = async () => {
    const res = await fetch(`${API_URL}/news`);
    const data = await res.json();
    setNewsList(data);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  // ================= HANDLE INPUT =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ================= ADD / UPDATE NEWS =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = editId
      ? `${API_URL}/news/${editId}`
      : `${API_URL}/add-news`;

    const method = editId ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const result = await res.json();
    alert(result.message || result.error);

    fetchNews();
    setOpen(false);
    setEditId(null);
    setFormData({ title: "", description: "", date: "" });
  };

  // ================= DELETE NEWS =================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this news?")) return;

    await fetch(`${API_URL}/news/${id}`, {
      method: "DELETE",
    });

    fetchNews();
  };

  return (
    <Box
      sx={{
        p: 3,
        mt: `${topbarHeight + 16}px`,
        backgroundColor: "#f5f5f5",
        minHeight: `calc(100vh - ${topbarHeight + 16}px)`,
      }}
    >
      <Typography variant="h4" mb={3} fontWeight="600">
        Dashboard News
      </Typography>

      <Button variant="contained" sx={{ mb: 3 }} onClick={() => setOpen(true)}>
        Add News
      </Button>

      {/* ================= NEWS LIST ================= */}
      <Grid container spacing={3}>
        {newsList.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card sx={{ height: "100%", borderLeft: "6px solid #1976d2" }}>
              <CardContent>
                <Typography variant="h6" color="text.secondary">{item.title}</Typography>
                <Typography sx={{ mt: 1 }} color="text.secondary">{item.description}</Typography>
                <Typography sx={{ mt: 1 }} color="text.secondary">
                  {new Date(item.news_date).toDateString()}
                </Typography>
              </CardContent>

              <CardActions>
                <IconButton
                  color="primary"
                  onClick={() => {
                    setEditId(item.id);
                  setFormData({
                  title: item.title,
                  description: item.description,
                  start_date: item.start_date,
                  end_date: item.end_date,
                });

                    setOpen(true);
                  }}
                >
                  <Edit />
                </IconButton>

                <IconButton color="error" onClick={() => handleDelete(item.id)}>
                  <Delete />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ================= MODAL ================= */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            width: { xs: "90%", sm: 500 },
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 3,
            mx: "auto",
            mt: "10%",
          }}
        >
          <Typography variant="h5" mb={3} textAlign="center">
            {editId ? "Edit News" : "Add News"}
          </Typography>

          <Paper elevation={0}>
            <form onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  fullWidth
                />

                <TextareaAutosize
                  minRows={5}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: 10,
                    borderRadius: 8,
                    border: "1px solid #ccc",
                  }}
                />

               <TextField
                type="date"
                name="start_date"
                label="Display Start Date"
                InputLabelProps={{ shrink: true }}
                value={formData.start_date}
                onChange={handleChange}
                required
                fullWidth
              />

              <TextField
                type="date"
                name="end_date"
                label="Display End Date"
                InputLabelProps={{ shrink: true }}
                value={formData.end_date}
                onChange={handleChange}
                required
                fullWidth
              />

                <Button type="submit" variant="contained" fullWidth>
                  {editId ? "Update" : "Submit"}
                </Button>
              </Stack>
            </form>
          </Paper>
        </Box>
      </Modal>
    </Box>
  );
};

export default DashboardNews;
